<template>
    <section v-if="items.length" class="">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeader title="Agenda & Schedule" prefix="Event!" :icon="CalendarClock" :options="layoutOptions"
                v-model="mode" />

            <component :is="viewComponent" :groups="groups" :event-location="eventLocation"
                :event-title="eventTitle" />
        </div>
    </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { CalendarClock, AlignLeft, PanelLeft, LayoutList } from 'lucide-vue-next';
import { EventAgendaItem } from '~/types';
import SectionHeader from './SectionHeader.vue';
import { buildGroups } from './EventAgenda/agenda';
import Standard from './EventAgenda/Standard.vue';
import TabsHorizontal from './EventAgenda/TabsHorizontal.vue';
import TabsVertical from './EventAgenda/TabsVertical.vue';

type AgendaLayout = 'standard' | 'tabs-horizontal' | 'tabs-vertical';

const props = withDefaults(
    defineProps<{
        items: EventAgendaItem[];
        variant?: AgendaLayout;
        eventLocation?: string | null;
        eventTitle?: string;
    }>(),
    { variant: 'tabs-vertical' }
);

const mode = ref<AgendaLayout>(props.variant);

const layoutOptions: { value: AgendaLayout; label: string; icon: any }[] = [
    { value: 'tabs-vertical', label: 'Day tabs (side)', icon: PanelLeft },
    { value: 'tabs-horizontal', label: 'Day tabs (top)', icon: LayoutList },
    { value: 'standard', label: 'All days', icon: AlignLeft },
];

const views = {
    'standard': Standard,
    'tabs-horizontal': TabsHorizontal,
    'tabs-vertical': TabsVertical,
};
const viewComponent = computed(() => views[mode.value] || TabsVertical);

const groups = computed(() => buildGroups(props.items));
</script>
